import { Dispatch } from "react";
import * as actionTypes from "../actionTypes/Index";
import {
  IActionType,
  IWarehouseCategory,
  IAddUpdateDeliveryDatePageState,
} from "../../interfaces/Index";
import {
  fetchWarehouseDeliveryConfig,
  createUpdateWarehouseDeliveryConfig,
  fetchByCityWareHouseListApiCall,
} from "redux/sources/DeliveryDateSource";

export const getDeliveryDateWareHouseNamesInit = () => ({
  type: actionTypes.GET_DELIVERY_DATE_WAREHOUSE_INIT,
});

export const getDeliveryDateWareHouseNamesSuccess = (
  payload: Array<IWarehouseCategory>
) => ({
  type: actionTypes.GET_DELIVERY_DATE_WAREHOUSE_SUCCESS,
  payload,
});

export const getDeliveryDateWareHouseNamesFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_DELIVERY_DATE_WAREHOUSE_FAIL,
  error,
});

export const fetchWarehouseDeliveryConfigInit = () => ({
  type: actionTypes.GET_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT,
});

export const fetchWarehouseDeliveryConfigSuccess = (
  payload: IAddUpdateDeliveryDatePageState
) => ({
  type: actionTypes.GET_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS,
  payload,
});

export const fetchWarehouseDeliveryConfigFail = (
  error: string | object | null
) => ({
  type: actionTypes.GET_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL,
  error,
});

export const createUpdateWarehouseDeliveryConfigInit = () => ({
  type: actionTypes.CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_INIT,
});

export const createUpdateWarehouseDeliveryConfigSuccess = () => ({
  type: actionTypes.CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_SUCCESS,
});

export const createUpdateWarehouseDeliveryConfigFail = (
  error: string | object | null
) => ({
  type: actionTypes.CREATE_UPDATE_WAREHOUSE_DELIVERY_DATE_CONFIG_FAIL,
  error,
});

export const fetchWarehouseDeliveryDateConfigAction =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(fetchWarehouseDeliveryConfigInit());
    return fetchWarehouseDeliveryConfig(id)
      .then((details: IAddUpdateDeliveryDatePageState) => {
        dispatch(fetchWarehouseDeliveryConfigSuccess(details));
      })
      .catch((e: object | null | string) =>
        dispatch(fetchWarehouseDeliveryConfigFail(e))
      );
  };

export const createUpdateWarehouseDeliveryDateConfigAction =
  (payload: any) => (dispatch: Dispatch<IActionType>) => {
    dispatch(createUpdateWarehouseDeliveryConfigInit());
    return createUpdateWarehouseDeliveryConfig(payload)
      .then(() => dispatch(createUpdateWarehouseDeliveryConfigSuccess()))
      .catch((e: object | null | string) =>
        dispatch(createUpdateWarehouseDeliveryConfigFail(e))
      );
  };

export const fetchByCityWareHouseListDeliveryDateAction =
  (id: string) => (dispatch: Dispatch<IActionType>) => {
    dispatch(getDeliveryDateWareHouseNamesInit());
    return fetchByCityWareHouseListApiCall(id)
      .then((wareHouseNames: Array<IWarehouseCategory>) =>
        dispatch(getDeliveryDateWareHouseNamesSuccess(wareHouseNames))
      )
      .catch((e: object | null | string) =>
        dispatch(getDeliveryDateWareHouseNamesFail(e))
      );
  };
